import React, { Component } from "react";
import { Link } from "gatsby";
import Slider from "react-slick";
import Img from "gatsby-image";
import { Next, Prev } from "./icons";

class Carousel extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.UrlToSlug = this.UrlToSlug.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  UrlToSlug(url) {
    const arr = url.split('/');
    arr.splice(0, 3);
    return arr.join('/');
  }
  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true
    };
    return (
      <div className="carousel">
        <Slider ref={c => (this.slider = c)} {...settings}>
          {this.props.items.map((item, i) => (
            <section className="hero" key={i}>
              <Img sizes={item.image.localFile.childImageSharp.sizes} alt={item.headline} />
              <div className="hero-body">
                <div className="container">
                  <div className="columns is-centered">
                    <div className="column is-8">
                      <h1 className="title">{item.headline}</h1>
                      <h2 className="subtitle">{item.subheadline}</h2>
                      <Link
                        to={this.UrlToSlug(item.button_link)}
                        className="button is-primary is-large"
                      >
                        {item.button_text}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ))}
        </Slider>
        <div className={this.props.items.length > 1 ? 'previous' : 'is-invisible'}>
          <button className="button" onClick={this.previous}>
            <Prev />
          </button>
        </div>
        <div className={this.props.items.length > 1 ? 'next' : 'is-invisible'}>
          <button className="button" onClick={this.next}>
            <Next />
          </button>
        </div>
      </div>
    );
  }
}

export default Carousel;
